'use client';

import ContactCardsComponent from '@/components/contactCards/ContactCards';
import type { ComponentContactCardsStoryblok } from '@/types/component-types-sb';

const ContactCards: React.FC<{
  blok: ComponentContactCardsStoryblok;
}> = ({ blok }) => {
  return <ContactCardsComponent contacts={blok.contacts} content={blok.content} blok={blok} />;
};

export default ContactCards;
